import Common from '@/utils/common'
const service = 'customer-api'

export const accountTypeList = [
  {
    accountName: '个人银行账户-借记卡',
    key: '01'
  },
  {
    accountName: '个人银行账户-贷记卡',
    key: '02'
  },
  {
    accountName: '企业对公账户',
    key: '00'
  }
]
// 转账到账户页面初始化
export function initTransToAccountOrBankApi(data) {
  return Common.createRequest('trade-api', 'TRANSFER_07', data)
}
// 转账到账户交易提交
export function submitTransToAccountApi(data) {
  return Common.createRequest('trade-api', 'TRANSFER_02', data)
}

// 转账到银行卡交易提交
export function submitTransToCardApi(data) {
  return Common.createRequest('trade-api', 'TRANSFER_01', data)
}

// 获取银行列表
export function getBankListApi(data) {
  return Common.createRequest('trade-api', 'TRANSFER_08', data)
}

// 自动转账页面初始化
export function initTransToAutoApi(data) {
  return Common.createRequest('merchant-api', 'AUTOPAYMENT0001', data)
}

// 自动转账提交
export function submitTransToAutoApi(data) {
  return Common.createRequest('merchant-api', 'AUTOPAYMENT0002', data)
}

// 自动转账修改
export function submitUpdateTransToAutoApi(data) {
  return Common.createRequest('merchant-api', 'AUTOPAYMENT0003', data)
}

// 通过银行卡号获取银行类型或者名称
export function queryBankByNameResp(data) {
  return Common.createRequest('trade-api', 'TRANSFER_541', data, '查询银行类型或者名称')
}

// 转账历史记录查询
export function queryPayRecord(data) {
  return Common.createRequest('trade-api', 'PAYMENT_INF_HIS_QUERY', data, '查询转账历史记录')
}


